import {Children, isValidElement, JSX, ReactNode} from "react";

import {HeroDescription} from "./hero-description";
import {HeroTitle} from "./hero-title";

interface HeroHeaderProps {
    children?: ReactNode;
}

export function HeroHeader({children}: HeroHeaderProps): JSX.Element {
    const processedChildren = Children.map(children, (child) => {
        if (!isValidElement(child)) return child;

        // Add wrapper with max-width for HeroTitle
        if (child.type === HeroTitle) {
            return <div className="hero__title-wrapper">{child}</div>;
        }

        // Add wrapper with max-width for HeroDescription
        if (child.type === HeroDescription) {
            return <div className="hero__description-wrapper">{child}</div>;
        }

        return child;
    });

    return <div className="hero__header">{processedChildren}</div>;
}
